/* eslint-disable */
import * as Types from '../../../shared/__gql-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetChartsByNameQueryVariables = Types.Exact<{
  type: Types.ChartNameTypeParameter;
  name: Types.Scalars['String'];
}>;


export type GetChartsByNameQuery = { __typename: 'Query', getChartsByName: Array<{ __typename: 'ChartName', artist: string | null, title: string | null }> | null };


export const GetChartsByNameDocument = gql`
    query getChartsByName($type: ChartNameTypeParameter!, $name: String!) {
  getChartsByName(type: $type, name: $name) {
    artist
    title
  }
}
    `;

/**
 * __useGetChartsByNameQuery__
 *
 * To run a query within a React component, call `useGetChartsByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChartsByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChartsByNameQuery({
 *   variables: {
 *      type: // value for 'type'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetChartsByNameQuery(baseOptions: Apollo.QueryHookOptions<GetChartsByNameQuery, GetChartsByNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChartsByNameQuery, GetChartsByNameQueryVariables>(GetChartsByNameDocument, options);
      }
export function useGetChartsByNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChartsByNameQuery, GetChartsByNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChartsByNameQuery, GetChartsByNameQueryVariables>(GetChartsByNameDocument, options);
        }
export type GetChartsByNameQueryHookResult = ReturnType<typeof useGetChartsByNameQuery>;
export type GetChartsByNameLazyQueryHookResult = ReturnType<typeof useGetChartsByNameLazyQuery>;